const styles = {
    container: {
        maxWidth: '100%',
        minHeight: '480px',
        mt: '24px',
    },
    group: {
        boxSizing: 'border-box',
        position: 'absolute',
        left: '50%',
        top: '50%',
    },
    image_group: {
        top: '50%',
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    path_one: {
        marginBottom: '80px',
        marginRight: '-16px',
    },
    path_two: {
        marginBottom: '121px',
        marginLeft: '4px',
        marginRight: '-80px',
    },
    path_three: {
        marginLeft: '18px',
        marginBottom: '30px',
    },
};

export default styles;
